import React from 'react'
import { Link } from "react-router-dom";
import image1 from '../../../images/all/1.jpg'
import image2 from '../../../images/all/4.jpg'
import image3 from '../../../images/all/6.jpg'
import { MdOutlinePhoneEnabled,MdEmail } from "react-icons/md";
import './Agent.css'

const Agent = () => {

  const decor = {
    textDecoration: 'none'
  }

  return (
      <div className="agent-container">
        <div className='agent-wrapper'>
          <div className="agent-img-container">
            <img className='agent-img' src={image1} alt="image1" />
          </div>
          <div className="agent-bg">
            <h5>Anna Lips</h5>
            <h4>Mavers Real Estate Agency</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in pulvinar neque. Nulla...</p>
            <hr className='hr' />
            <div className="agent-user">
              <div className="user">                   
                 <Link style={decor} to="/" className='views'><li >View Profile</li></Link>              
              </div>
              <div className="rating">
                <div className="user-contact">
                    <MdOutlinePhoneEnabled className='userr' />
                    <MdEmail className='userr'/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='agent-wrapper'>
          <div className="agent-img-container">
            <img className='agent-img' src={image3} alt="image1" />
          </div>
          <div className="agent-bg">
            <h5>Jane Kobart</h5>
            <h4>Mavers Real Estate Agency</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in pulvinar neque. Nulla...</p>
            <hr className='hr' />
            <div className="agent-user">
              <div className="user">                   
                 <Link style={decor} to="/" className='views'><li >View Profile</li></Link>              
              </div>
              <div className="rating">
                <div className="user-contact">
                    <MdOutlinePhoneEnabled className='userr' />
                    <MdEmail className='userr'/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='agent-wrapper'>
          <div className="agent-img-container">
            <img className='agent-img' src={image2} alt="image1" />
          </div>
          <div className="agent-bg">
            <h5>Bill Trust</h5>
            <h4>Sweet Home Agency</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in pulvinar neque. Nulla...</p>
            <hr className='hr' />
            <div className="agent-user">
              <div className="user">                   
                 <Link style={decor} to="/" className='views'><li >View Profile</li></Link>              
              </div>
              <div className="rating">
                <div className="user-contact">
                    <MdOutlinePhoneEnabled className='userr' />
                    <MdEmail className='userr'/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Agent